module.exports = __webpack_public_path__ + "img/AskAI.59cd7d78.png";